import React, { Component } from 'react'
// import { Link } from 'react-router-dom'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'
import { Form, DatePicker, Input, Row, Col, Select, Spin } from 'antd'
// import provinces from '../../data/provinces'
import nationalities from '../../data/nationalities'
import { EditProfilePageContent } from '~/styles'
const { Option } = Select
const FormItem = Form.Item
class EditProfilePage extends Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // console.log(values.profile.birthDate)
        // console.log('Received values of form: ', values)
        this.props.updateUser({
          variables: {
            data: values
          }
        })
        this.props.history.push('/profile')
      }
    })
  }

  render () {
    // console.log(this.props.data)
    const { currentUser } = this.props.data

    if (!currentUser) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    }

    const { email, profile, _id } = currentUser
    const { getFieldDecorator } = this.props.form
    const {
      birthDate,
      gender,
      nationality,
      firstName,
      lastName,
      telephone
    } = profile

    const dateFormat = 'DD/MM/YYYY'
    // function toDate (time) {
    //   return moment(time).subtract(10, 'days').calendar()
    // }

    getFieldDecorator('_id', {
      initialValue: _id
    })
    getFieldDecorator('email', {
      initialValue: email
    })

    return (
      <EditProfilePageContent>
        <Form onSubmit={this.handleSubmit}>
          <div className="profileBox">
            <div className="inProfileBox">
              <div className="profileIcon">
                {/* <img src="/ico-userregister.png" alt=""/> */}
                {/* <Link to='/profile/edit' className='editProfile'>Edit</Link> */}
              </div>
              <div className="shape profilePage">
                <span className="shapeTitle">Profile Info</span>
              </div>
              <Row>
                <Col xs={24} md={12}>
                  <div className="profileInfo">
                    <p className="profileInfoTitle">First Name</p>
                    <div className="profileInfoDataBox">
                      <FormItem label="Last Name" hasFeedback>
                        {getFieldDecorator('profile.firstName', {
                          initialValue: firstName,
                          rules: [
                            {
                              required: true,
                              message: 'Please input your First Name'
                            }
                          ]
                        })(<Input />)}
                      </FormItem>
                    </div>
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="profileInfo">
                    <p className="profileInfoTitle">Last Name</p>
                    <div className="profileInfoDataBox">
                      <FormItem label="Last Name" hasFeedback>
                        {getFieldDecorator('profile.lastName', {
                          initialValue: lastName,
                          rules: [
                            {
                              required: true,
                              message: 'Please input your Last Name'
                            }
                          ]
                        })(<Input />)}
                      </FormItem>
                    </div>
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="profileInfo">
                    <p className="profileInfoTitle">Birth Date</p>
                    <div className="profileInfoDataBox">
                      <FormItem label="Birth Date" hasFeedback>
                        {getFieldDecorator('profile.birthDate', {
                          initialValue: birthDate ? moment(birthDate) : '',
                          rules: [
                            {
                              required: true,
                              message: 'Please input your Birth Date'
                            }
                          ]
                        })(<DatePicker format={dateFormat} />)}
                      </FormItem>
                    </div>
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="profileInfo">
                    <p className="profileInfoTitle">Gender</p>
                    <div className="profileInfoDataBox">
                      <span className="profileInfoData">
                        <FormItem label="Gender" hasFeedback>
                          {getFieldDecorator('profile.gender', {
                            initialValue: gender,
                            rules: [
                              {
                                required: true,
                                message: 'Please input your Gender!'
                              }
                            ]
                          })(
                            <Select placeholder="Select a option and change input text above">
                              <Option value="male">male</Option>
                              <Option value="female">female</Option>
                            </Select>
                          )}
                        </FormItem>
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="profileInfo">
                    <p className="profileInfoTitle">Telephone</p>
                    <div className="profileInfoDataBox">
                      <span className="profileInfoData">
                        <FormItem label="Telephone" hasFeedback>
                          {getFieldDecorator('profile.telephone', {
                            initialValue: telephone,
                            rules: [
                              {
                                pattern: /^[+][0-9]+?$|^[0-9]+?$/,
                                required: true,
                                message: 'Please enter telephone number correctly'
                              }
                            ]
                          })(<Input />)}
                        </FormItem>
                      </span>
                    </div>
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="profileInfo">
                    <p className="profileInfoTitle">Nationality</p>
                    <div className="profileInfoDataBox">
                      <span className="profileInfoData">
                        <FormItem label="Nationality" hasFeedback>
                          {getFieldDecorator('profile.nationality', {
                            initialValue: nationality,
                            rules: [
                              {
                                required: true,
                                message: 'Please input your Nationality!'
                              }
                            ]
                          })(
                            <Select
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0}
                            >
                              {nationalities.map(nationality => (
                                <Select.Option
                                  key={nationality}
                                  value={nationality}
                                >
                                  {nationality}
                                </Select.Option>
                              ))}
                            </Select>
                          )}
                        </FormItem>
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
              {/* <div className="shape profilePage">
                          <span className='shapeTitle'>Contract Info</span>
                      </div>
                      <Row>
                          <Col xs={24} md={12}>
                              <div className='profileInfo'>
                                  <p className='profileInfoTitle'>Address</p>
                                  <div className='profileInfoDataBox'>
                                      <span className='profileInfoData'>
                                          1234 BKK
                                      </span>
                                  </div>
                              </div>
                          </Col>
                          <Col xs={24} md={12}>
                              <div className='profileInfo'>
                                  <p className='profileInfoTitle'>Province</p>
                                  <div className='profileInfoDataBox'>
                                    <span className='profileInfoData'>
                                          Bangkok
                                      </span>
                                  </div>
                              </div>
                          </Col>
                          <Col xs={24} md={12}>
                              <div className='profileInfo'>
                                  <p className='profileInfoTitle'>Country</p>
                                  <div className='profileInfoDataBox'>
                                    <span className='profileInfoData'>
                                          Thai
                                      </span>
                                  </div>
                              </div>
                          </Col>
                          <Col xs={24} md={12}>
                              <div className='profileInfo'>
                                  <p className='profileInfoTitle'>Tel</p>
                                  <div className='profileInfoDataBox'>
                                    <span className='profileInfoData'>
                                          0851469556
                                      </span>
                                  </div>
                              </div>
                          </Col>
                          <Col xs={24} md={12}>
                              <div className='profileInfo'>
                                  <p className='profileInfoTitle'>E-mail</p>
                                  <div className='profileInfoDataBox'>
                                    <span className='profileInfoData'>
                                          {email}
                                      </span>
                                  </div>
                              </div>
                          </Col>
                      </Row> */}
              <div className="editProfileBox">
                <div className="editProfileButton" onClick={this.handleSubmit}>
                  save
                </div>
              </div>
            </div>
          </div>

        </Form>
      </EditProfilePageContent>
    )
  }
}

const currentUser = gql`
  query {
    currentUser {
      _id
      email 
      profile {
        _id
        imageUrl
        firstName
        lastName
        birthDate
        nationality
        gender
        telephone
      }
    }
  }
`
const updateUser = gql`mutation ($data: UpdateByIdUserInput!) {
  updateUser(record: $data) {
    record {
      _id
      profile {
        _id
        imageUrl
        firstName
        lastName
        birthDate
        nationality
        gender
        telephone
      }
    }
  }
}`

// const EditProfilePageWithData = graphql(currentUser)(EditProfilePage)

export default compose(
  Form.create(),
  graphql(updateUser, {
    name: 'updateUser'
  }),
  graphql(currentUser)
)(EditProfilePage)



// WEBPACK FOOTER //
// ./src/App/EditProfilePage/EditProfilePage.js